import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CookieBanner from "@/components/CookieBanner";
import Basra from "@/components/Basra";
import { useApp } from "@/context/AppContext";

export default function Layout() {
  const loc = useLocation();
  const { track } = useApp();
  useEffect(() => { track("page_view", { path: loc.pathname }); window.scrollTo(0, 0); }, [loc.pathname, track]);
  return (
    <div className="min-h-screen flex flex-col grain bg-[#0A0A0A]">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <CookieBanner />
      <Basra />
    </div>
  );
}
